function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#008873",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 14V1"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M17 1h6v18H1V1h6"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M17 9l-5 5-5-5"
}));

function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+ZG93bmxvYWQ8L3RpdGxlPgogICAgPGcgaWQ9IlJFU09VUkNFLURFVEFJTFMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIwMzAtd2dhLWxpYnJhcnktcmVzb3VyY2UtZGV0YWlscyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5OS4wMDAwMDAsIC0yODU5LjAwMDAwMCkiIHN0cm9rZT0iIzAwODg3MyIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9ImRvd25sb2FkLWxpbmsiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwMC4wMDAwMDAsIDI4NTUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iZG93bmxvYWQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCA1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxMSIgeTE9IjEzIiB4Mj0iMTEiIHkyPSIwIiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgcG9pbnRzPSIxNiAwIDIyIDAgMjIgMTggMCAxOCAwIDAgNiAwIj48L3BvbHlsaW5lPgogICAgICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgcG9pbnRzPSIxNiA4IDExIDEzIDYgOCI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgDownloadIcon as ReactComponent };